export default "__VITE_ASSET__BdvvMCPT__"